import { BookOpen, Target, Shield, Heart } from 'lucide-react';
import { Helmet } from 'react-helmet';
// Importation du CSS via l'alias de chemin
// Cela garantit que le bundler (Vite/Webpack) trouve le fichier APropos.css dans le dossier 'src'
import '@/APropos.css'; 

const APropos = () => {
  return (
    <>
        <Helmet>
            <title>À Propos - Savoir des Pierres</title>
            <meta 
                name="description" 
                content="Savoir des Pierres : Un guide passionné pour vous aider à mieux comprendre les pierres naturelles et leurs énergies. Des connaissances claires et accessibles." 
            />
        </Helmet>
        
        <main className="apropos-container">
          {/* Hero Section */}
          <section className="hero">
            <h1 className="hero-title">À Propos</h1>
            <p className="hero-text">
              Une encyclopédie de référence en lithothérapie, construite avec passion pour transmettre des connaissances sur les pierres naturelles.
            </p>
          </section>

          {/* Mission Cards */}
          <section className="cards-section">
            <div className="card-grid">
              <div className="value-card">
                <div className="card-icon-wrapper">
                  <Target className="card-icon" size={32} />
                </div>
                <h3 className="card-title">Notre Mission</h3>
                <p className="card-text">
                  Vous transmettre les propriétés des pierres naturelles, afin qu'elles soient accessible à tous les passionnés.
                </p>
              </div>

              <div className="value-card">
                <div className="card-icon-wrapper">
                  <BookOpen className="card-icon" size={32} />
              </div>
                <h3 className="card-title">Éducation</h3>
                <p className="card-text">
                  En apprendre plus sur les usages, les bienfaits, l'histoire, la composition chimique et cristallographique des pierres naturelles.
                </p>
              </div>

              <div className="value-card">
                <div className="card-icon-wrapper">
                  <Shield className="card-icon" size={32} />
              </div>
                <h3 className="card-title">Rigueur</h3>
                <p className="card-text">
                  Fournir des fiches de pierres détaillées et structurées, combinant données claires et connaissances énergétiques.
                </p>
              </div>

              <div className="value-card">
                <div className="card-icon-wrapper">
                  <Heart className="card-icon" size={32} />
              </div>
                <h3 className="card-title">Passion</h3>
                <p className="card-text">
                  Partager notre passion pour les pierres naturelles avec une communauté de passionnés et de curieux.
                </p>
              </div>
            </div>
          </section>

          {/* Méthodologie Section */}
          <section className="methodology-section">
            <h2 className="section-title">Notre Méthodologie</h2>
            <div className="methodology-content">
              <div className="methodology-item">
                <h3 className="methodology-heading">Notre passion, votre découverte</h3>
                <p className="methodology-text">
                  Ce site est né d'un profond intérêt pour l'univers fascinant des pierres naturelles et des minéraux. Notre objectif est de partager cette passion en vous offrant des connaissances claires et accessibles à tous.
                </p>
              </div>

              <div className="methodology-item">
                <h3 className="methodology-heading">Partage d'Informations</h3>
                <p className="methodology-text">
                  Le contenu que vous trouverez ici est basé sur des recherches, des lectures, des traditions ancestrales et des retours d'expériences personnelles et collectives. Nous souhaitons simplement mettre ces connaissances à disposition de tous ceux qui s'y intéressent.
                </p>
              </div>

              <div className="methodology-item">
                <h3 className="methodology-heading">Une approche de bien-être personnel</h3>
                <p className="methodology-text">
                  Les informations présentées sur les propriétés ou les usages des pierres sont données à titre indicatif et visent à enrichir votre connaissance personnelle. Elles font partie d'une approche de bien-être et de tradition qui ne peut en aucun cas se substituer à un avis ou un traitement médical.
                </p>
              </div>

              <div className="methodology-item">
                <h3 className="methodology-heading">Mise à Jour Continue</h3>
                <p className="methodology-text">
                  Cette encyclopédie est un projet vivant. Nous enrichissons régulièrement notre base de données et affinons nos informations selon les nouvelles découvertes.
                </p>
              </div>
            </div>
          </section>

          {/* Disclaimer Section */}
          <section className="disclaimer-section">
            <h2 className="disclaimer-title">Avertissement Important</h2>
            <p className="disclaimer-text">
              <strong>Le Savoir des Cristaux</strong> est un site à vocation purement <strong>éducative et informative</strong>. Les informations présentées sur ce site concernant la lithothérapie et les propriétés énergétiques des pierres ne constituent en aucun cas un avis médical, un diagnostic ou une prescription thérapeutique.
            </p>
            <p className="disclaimer-text">
              La lithothérapie est une approche holistique complémentaire qui <strong>ne remplace jamais un traitement médical conventionnel</strong>. En cas de problème de santé physique ou psychologique, consultez impérativement un professionnel de santé qualifié (médecin, psychiatre, psychologue).
            </p>
            <p className="disclaimer-text">
              Ce site ne vend aucun produit et n'est affilié à aucune boutique de vente de pierres. Notre seul objectif est de partager des connaissances fiables et accessibles.
            </p>
          </section>

          {/* L'ancien bloc <style> a été supprimé et remplacé par l'importation CSS. */}
      </main>
    </>
  );
};

export default APropos;